import React, { createContext, useContext, useState, ReactNode } from "react";

interface AppContextProps {
  isCollapsed: boolean;
  toggleCollapse: () => void;
}

const AppContext = createContext<AppContextProps | undefined>(undefined);

const AppProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);

  const toggleCollapse = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <AppContext.Provider value={{ isCollapsed, toggleCollapse }}>
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for using the AppContext
const useAppContext = (): AppContextProps => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error("useAppContext must be used within an AppProvider");
  }
  return context;
};

export { AppProvider, useAppContext };
